export default __webpack_public_path__ + "static/media/3.4269fce2.png";